import api from "../../../../../utils/axiosInstance";
import VendorScopedSection from "../shared/VendorScopedSection";
import VendorServicesTable from "./VendorServicesTable";
import EditServicePage from "./EditServicesPage";

const fetchData = async (vendorId) => {
  const [settingsRes, itemsRes] = await Promise.all([
    api.get(`/vendor-settings/${vendorId}`, { withCredentials: true }),
    api.get(`/vendor-services/${vendorId}/services`, { withCredentials: true }),
  ]);

  const data = itemsRes.data?.data;
  const items = Array.isArray(data)
    ? data
    : Array.isArray(data?.services)
    ? data.services
    : [];

  return {
    worksWithAll: settingsRes.data?.data?.works_with_all_services || false,
    items,
  };
};

const onToggle = async (vendorId, newValue) => {
  if (!newValue) {
    await api.post("/vendor-services/initialize", {
      vendor_id: parseInt(vendorId),
    });
  }
  await api.put(`/vendor-settings/${vendorId}`, {
    works_with_all_services: newValue,
  });
};

const VendorServicesPage = ({ vendorId }) => (
  <VendorScopedSection
    vendorId={vendorId}
    toggleLabel="Works with all services:"
    helperText="This vendor works with all services."
    sectionTitle="Services"
    containerMaxWidth="max-w-2xl"
    editModalTitle="Manage Vendor Services"
    editModalMaxWidth="max-w-2xl"
    fetchData={fetchData}
    onToggle={onToggle}
    renderTable={({ items }) => <VendorServicesTable services={items} />}
    renderEdit={({ onComplete }) => (
      <EditServicePage vendorId={vendorId} onUpdateComplete={onComplete} />
    )}
  />
);

export default VendorServicesPage;
